import university from './university';
import candidate from './candidate';
import candidateIndeed from './candidate-indeed';
import universityIndeed from './university-indeed';
import applyIndeed from './apply-indeed';
import cvbuilderIndeed from './cvbuilder-indeed';
import cvbuilder from './cvbuilder';
import apply from './apply';
import applyLong from './apply-long';
import summerjob from './summerjob';
import summerjobIndeed from './summerjob-indeed';

export const CONFIGS = {
  university,
  candidate,
  cvbuilder,
  apply,
  applyLong,
  summerjob,
  candidateIndeed,
  applyIndeed,
  cvbuilderIndeed,
  universityIndeed,
  summerjobIndeed
};

export default function config(signupFor, siteAbbr = []) {
  const selectedConfig = CONFIGS[signupFor];

  if (!selectedConfig) {
    throw new ReferenceError(`No configs found with name ${signupFor}`);
  }
  const selectedConfigFiltered = selectedConfig(siteAbbr);

  return selectedConfigFiltered;
}
